import React from 'react';
import PropTypes from 'prop-types';

import { VIMEO_VENUES_BASE_URL } from '@techchange/components';

import { BOOTSTRAP_ASPECT_RATIOS_V4_TO_V5 } from '../../utils/constants';
import { isSafeUrl } from '../../../../utils/urls';

const propTypes = {

	/**
	 * The unique ID for the content.
	 */
	id: PropTypes.string,

	/**
	 * Additional data for the content.
	 */
	data: PropTypes.shape({

		/**
		 * True, if the embed is for an articulate project.
		 */
		articulate: PropTypes.bool,

		/**
		 * The embed url.
		 */
		src: PropTypes.string,

		/**
		 * The embed aspect ratio.
		 */
		aspectRatio: PropTypes.string,

	}),

	/**
	 * The title to display.
	 */
	title: PropTypes.string,

	/**
	 * Flag indicating if the content title should be visible.
	 */
	showTitle: PropTypes.bool,

};

const ContentDisplay = (props) => {

	const {
		data,
		title,
		showTitle,
	} = props;

	if (!data || !isSafeUrl(data.src)) {
		return null;
	}

	const { articulate, src, aspectRatio } = data;

	const isVenues = src?.indexOf(VIMEO_VENUES_BASE_URL) === 0;

	let sandbox, allow;

	if (articulate) {
		sandbox = 'allow-scripts allow-same-origin allow-popups';
	}

	if (isVenues) {
		// eslint-disable-next-line max-len
		sandbox = 'allow-forms allow-modals allow-scripts allow-same-origin';
		// eslint-disable-next-line max-len
		allow = 'camera;microphone;fullscreen;screen-wake-lock;display-capture;allow-scripts;allow-same-origin;autoplay';
	}

	return (
		<div>
			{showTitle &&
				<span className="title">
					<h5 style={{ margin: 0 }}>
						{title}
					</h5>
				</span>
			}
			<div className={`ratio ratio-${BOOTSTRAP_ASPECT_RATIOS_V4_TO_V5[aspectRatio]}`}>
				<iframe
					src={src}
					frameBorder="0"
					sandbox={sandbox}
					title={title}
					allow={allow}
					allowFullScreen />
			</div>
		</div>
	);

};

ContentDisplay.propTypes = propTypes;

export default ContentDisplay;
